import React from "react";
import Navigation from "../../components/Navigation/Navigation";
import { Row, Breadcrumb } from "react-bootstrap";
import ManageTripRequests from "../../components/Dashboard/ManageTripRequests";
import Loader from "../../components/Common/Loader";

class ManageTripRequestsPage extends React.Component {
  state = {
    sideMenu: true,
    loading: true,
  };

  componentDidMount() {
    this.myInterval = setInterval(() => {
      this.setState({ loading: false });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.myInterval);
  }

  _onSideMenu = (active) => {
    this.setState({ sideMenu: active });
  };

  render() {
    let loader = null;
    if (this.state.loading) {
      loader = <Loader message="Loading..." />;
    }

    return (
      <div className="page-wrapper">
        <Navigation onClick={this._onSideMenu} />

        <div
          className={`main-content d-flex flex-column ${
            this.state.sideMenu ? "" : "hide-sidemenu"
          }`}
        >
          {loader}

          <div className="main-content-header">
            <Breadcrumb>
              <h1>Gestionar Solicitudes de Viaje</h1>
            </Breadcrumb>
          </div>

          <Row>
            <ManageTripRequests />
          </Row>
        </div>
      </div>
    );
  }
}

export default ManageTripRequestsPage;
